var _path, _circle;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgInfoCircle = function SvgInfoCircle(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6704 8.43286C13.3432 8.43286 13.8887 7.88743 13.8887 7.2146C13.8887 6.54177 13.3432 5.99634 12.6704 5.99634C11.9976 5.99634 11.4521 6.54177 11.4521 7.2146C11.4521 7.88743 11.9976 8.43286 12.6704 8.43286ZM12.1377 9.98813C11.8616 9.98813 11.6377 10.212 11.6377 10.4881V17.5038C11.6377 17.78 11.8616 18.0038 12.1377 18.0038H13.2273C13.5034 18.0038 13.7273 17.78 13.7273 17.5038V10.4881C13.7273 10.212 13.5034 9.98813 13.2273 9.98813H12.1377Z",
    fill: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.6699,
    cy: 12,
    r: 10.25,
    stroke: "currentColor",
    strokeWidth: 1.5,
    fill: "none"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgInfoCircle);
export default ForwardRef;